/**
 * document.exitPointerLock is undefined on iOS.
 * - Tested on iOS Safari 15.6.1.
 */
export function patchExitPointerLock() {
  const exitPointerLock = 'exitPointerLock' in document ? document.exitPointerLock.bind(document) : undefined;
  document.exitPointerLock = () => {
    exitPointerLock?.();
  };
}
